module.exports = __webpack_public_path__ + "img/vis_01.910c7421.jpg";